import { Form, FormInstance, Row } from 'antd'
import { ApplicationsState, FormState } from '@/state'

import './styles.scss'
import RenderMultipleSections from './multipleSections'
import RenderSimpleSection from './simple'
import { TApplication } from '@/interfaces'

export default function EntityDefaultForm({ form }: { form: FormInstance }) {
  const hasMultipleSections =
    (FormState.currentEntity.value?.sections?.length || 0) > 1

  const handleChangeValues = (
    _: TApplication,
    allValues: TApplication
  ): void => {
    FormState.currentFormValues.value = {
      ...FormState.currentFormValues.peek(),
      ...allValues,
      ...ApplicationsState.currentEntityFilesData.peek(),
    }
  }

  return (
    <Row gutter={20} justify='space-around'>
      <Form
        labelWrap
        labelAlign='left'
        layout='vertical'
        className='entity-form'
        form={form}
        disabled={
          ApplicationsState.viewMode.value.view ||
          !FormState.currentEntity.value?.permission?.edit
        }
        onValuesChange={handleChangeValues}
      >
        {hasMultipleSections ? (
          <RenderMultipleSections
            sections={FormState.currentEntity.value?.sections ?? []}
          />
        ) : (
          <RenderSimpleSection
            entitySection={(FormState.currentEntity.value?.sections ?? [])[0]}
          />
        )}
      </Form>
    </Row>
  )
}
